package com.essntl.uikit.components.card

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsCard(
    title: String,
    subtitle: String,
    actionButtons: @Composable RowScope.() -> Unit = {},
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .background(color = MaterialTheme.esColorScheme.bgPrimary)
            .padding(1.5f.spacing),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(2.5f.spacing),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(
                horizontalAlignment = Alignment.Start,
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.esTypography.p1Medium16.copy(
                        color = MaterialTheme.esTypography.p1Medium16.color,
                    ),
                )

                Text(
                    text = subtitle,
                    style = MaterialTheme.esTypography.p2Regular14.copy(
                        color = MaterialTheme.esColorScheme.textSecondary,
                    ),
                )
            }
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(1.5f.spacing),
        ) {
            actionButtons()
        }
    }
}